.gutter {
  position: absolute;
  top: 0;
  left: -16px;
  transform: translateX(-100%);
  display: flex;
  height: 100%;
  justify-content: center;
  width: 20px;
  transition: opacity 0.2s;
  border-radius: 0;
}

.gutter--right {
  left: auto;
  right: -16px;
  transform: translateX(100%);
}

.gutter--right .label {
  left: auto;
  right: 8px;
  transform: rotate(0deg);
}

.gutterButton {
  min-width: 24px;
  height: 24px;
  padding: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  opacity: 0;
  z-index: 1;
  transition: opacity 0.15s;
}

/* Show on block hover — .gutter is a direct child of the block's InnerTag */
*:hover > .gutter .gutterButton {
  opacity: 0.5;
}

/* Persist the handle once the block is selected, so reaching it doesn't
 * depend on a continuous hover path. Once the user has clicked into a block
 * the handle stays visible until selection moves elsewhere. */
.gutter--focused .gutterButton {
  opacity: 0.5;
}

.gutterButton:hover {
  opacity: 0.8;
}

.menuIcon {
  position: absolute;
  top: 0;
  left: 0;
  color: var(--tuna-palette-text-secondary);
}


.label {
  left: 8px;
  text-transform: uppercase;
  color: var(--tuna-palette-text-secondary);
  writing-mode: vertical-rl;
  text-align: center;
  position: relative;
  transform: rotate(180deg);
  white-space: nowrap;
  user-select: none;
  pointer-events: none;
  height: 100%;
}

.label--focused {
  color: var(--tuna-palette-primary-main);
}

/* On touch devices, keep the button visible since there is no hover */
@media (hover: none) {
  .gutterButton {
    opacity: 0.5;
    min-width: 44px;
    min-height: 44px;
  }
}

@media (max-width: 599.95px) {
  .gutter {
    left: -4px;
    width: 16px;
  }

  .gutter--right {
    left: auto;
    right: -4px;
  }

  .label {
    left: 4px;
    font-size: 0.65rem;
  }

  .gutter--right .label {
    left: auto;
    right: 4px;
  }
}
